module.exports = __webpack_public_path__ + "7b40f7f98f2032a9221b68e8a341c377.png";